import React from 'react';

interface TestTileProps {
  id: string;
  title: string;
  color?: string;
}

export const TestTile: React.FC<TestTileProps> = ({ 
  id, 
  title, 
  color = 'var(--accent-blue)' 
}) => {
  return (
    <div 
      className="test-tile"
      style={{
        background: `linear-gradient(135deg, ${color}, var(--accent-green))`,
        border: '2px solid var(--border-color)',
        borderRadius: 'var(--radius-medium)',
        padding: '16px',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100%',
        userSelect: 'none',
        cursor: 'grab',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s ease'
      }}
    >
      <h3 style={{ 
        margin: 0, 
        fontSize: '18px', 
        fontWeight: '600',
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
      }}>
        {title}
      </h3>
      <p style={{ 
        margin: '8px 0 0 0', 
        fontSize: '12px', 
        opacity: 0.9,
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
      }}>
        ID: {id}
      </p>
      <p style={{ 
        margin: '4px 0 0 0', 
        fontSize: '12px', 
        opacity: 0.9,
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
      }}>
        2x2 grid cells
      </p>
    </div>
  );
};